import { Component, ElementRef, inject } from '@angular/core';
import { EnvironmentService } from 'projects/bis-shared/src/lib/environment/environment.service';
//import { AppInsightsService } from '@markpieszak/ng-application-insights';
import { Idle } from '@ng-idle/core';
import { DialogService } from 'projects/bis-shared/src/lib/dialog/dialog.service';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { Router, RouterOutlet } from '@angular/router';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { IdleService } from 'projects/bis-shared/src/lib/utility/idle.service';
import { GenericDialogData } from 'projects/bis-shared/src/lib/dialog/generic-dialog/generic-dialog-data';
import * as moment from 'moment-timezone';
import { NavigationComponent } from './navigation/navigation.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports:[RouterOutlet, NavigationComponent, FooterComponent],
})
export class AppComponent {
  private envService = inject(EnvironmentService);
  private element = inject(ElementRef);
  private idle = inject(Idle);
  private idleService = inject(IdleService);
  private dialogService = inject(DialogService);
  private identityService = inject(IdentityService);
  private router = inject(Router);
  
  askedUserToSetupProfile: boolean;
  appInitialized: boolean;

  
 

  constructor() {
    this.identityService.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        if (this.appInitialized) {
          this.idleService.startIdle();
        } else {
          if (this.idleService.userHasTimedOut()) {
            //The user opened a new tab to OnBoard and should be idle yet is still logged in.
            //This can happen if they closed all tabs to OnBoard and re-opend before the access token became invalid
            //but after the idle timeout. Let's log them out now without a warning.
            this.identityService.logout(false);
            return;
          }
          this.appInitialized = true;
          this.showSetupModal();
          // initialize userGroup call so response is faster when used in application
          this.identityService.getUserGroups().subscribe();
          this.initIdle();
        }
      } else {
        this.idleService.stopIdle();
      }
    });

    // appInsightsService.config = {
    //   instrumentationKey: envService.getEnvironment().appInsightsKey,
    //   endpointUrl: envService.getEnvironment().appInsightsEndpointUrl,
    // };

    // appInsightsService.init();
    // const onBoardVersion = envService.getEnvironment().onBoardVersion;
    // if (onBoardVersion) {
    //   appInsightsService.queue.push(() => {
    //     appInsightsService.context.addTelemetryInitializer(envelope => {
    //       ((envelope.data ??= {}).baseData ??= {}).properties ??= {};
    //       envelope.data.baseData.properties.OnBoardVersion = onBoardVersion;
    //     });
    //   });
    // }

    moment.tz.setDefault('America/New_York');
  }

  private initIdle = () => {
    if (this.identityService.isLoggedIn()) {
      this.idleService.initIdle(this.element);
      this.idle.onIdleStart.subscribe(() => {
        if (this.identityService.isLoggedIn()) {
          // Show logout warning dialog
          if (this.router.url !== '/logout' && this.router.url !== '/login') {
            const logoutDialogRef = this.dialogService.showLogoutDialog();
            logoutDialogRef.afterClosed().subscribe(this.idleService.onIdleRefresh);
            logoutDialogRef.backdropClick().subscribe(() => this.idleService.onIdleRefresh(true));
          }
        } else {
          this.idleService.onIdleTimeout(true);
        }
      });
      this.idleService.startIdle();
    }
  };

  private showSetupModal() {
    if (this.envService.getEnvironment().featureFlags.onBoardLimitedRelease) {
      if (
        !this.identityService.apiToken.lastLoginDateTime &&
        !this.askedUserToSetupProfile &&
        this.identityService.identity.entityGroups?.length
      ) {
        this.askedUserToSetupProfile = true;
        const data: GenericDialogData = {
          title: 'Welcome!',
          body:
            'Before you get started, we just need you to take a moment to finish setting up your profile.',
          buttons: [{ text: 'Set Up Profile', value: true, default: true }],
        };
        this.dialogService.showGenericDialog(data).subscribe(setUpProfile => {
          if (setUpProfile) {
            this.router.navigate([AppUrls.userProfile()]);
          }
        });
      }
    }
  }
}
